import React, { useState, useEffect, FC } from "react";
import axios from "axios";
import ReactPlayer from "react-player";
import { useCompanyMedia } from "queryHooks";
import "./styles.scss";
import { IAnyProps, ICompanyProps } from "../../Types/Types";

const CompanyMediaDetail: FC<ICompanyProps> = (props: ICompanyProps) => {
  const { company = {} }: IAnyProps = props;

  const { data: companyMedia = [] } = useCompanyMedia({
    companyId: company.company_id,
  });

  const [activeMediaItem, setActiveMediaItem] = useState({});

  useEffect(() => {
    if (!company) {
      return;
    }

    if (!companyMedia) {
      return;
    }

    if (!companyMedia.length) {
      return;
    }

    setActiveMediaItem(companyMedia[0]);
  }, [company]);

  return (
    <div>
      <ActiveCarouselItem mediaItem={activeMediaItem} />

      <ThumbnailCarousel
        mediaItems={companyMedia ? companyMedia : []}
        company={company}
        activeMediaItem={activeMediaItem}
        setActiveMediaItem={setActiveMediaItem}
      />
    </div>
  );
};

export default CompanyMediaDetail;

const ActiveCarouselItem = ({ mediaItem }: IAnyProps) => {
  return (
    <div className="ps-company-media-content__active-content-container">
      {mediaItem.type === "video" && (
        <div>
          {mediaItem.video_host === "youtube" && (
            <div className={`ps-company-media-content__item-container`}>
              <div className="ps-company-media-content__react-player-wrapper">
                <ReactPlayer
                  // url={`https://www.youtube.come?v=${mediaItem.video_id}`}
                  url={`https://youtu.be/${mediaItem.video_id}`}
                  className="ps-company-media-content__react-player"
                  controls={true}
                  // playing
                  width="100%"
                  height="100%"
                />
              </div>
              {/* <iframe
                className="ps-company-media-content__item"
                data-src={`https://www.youtube.com/embed/${
                  mediaItem.video_id
                }?mute=1&enablejsapi=1&rel=0${
                  index === 0 ? "active" : ""
                }&autoplay=1`}
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe> */}
            </div>
          )}

          {/* {media.video_host === "wistia" && (
            <div className={`carousel-item ${index === 0 ? "active" : ""}`} style={{height: "auto"}} index={index}>
              {{> embeds/wistiaVideoEmbedPlayer}}
            </div> 

        )}*/}

          {mediaItem.video_host === "vimeo" && (
            <div>
              <div className="ps-company-media-content__react-player-wrapper">
                <ReactPlayer
                  url={`https://vimeo.com/${mediaItem.video_id}`}
                  className="ps-company-media-content__react-player"
                  controls={true}
                  // playing
                  width="100%"
                  height="100%"
                />
              </div>
            </div>
          )}
        </div>
      )}

      {mediaItem.type === "image" && (
        <img
          className="ps-company-profile-media__active-image"
          src={mediaItem.image_url}
          alt=""
        />
      )}
    </div>
  );
};

const ThumbnailCarousel = ({
  mediaItems,
  company,
  activeMediaItem,
  setActiveMediaItem,
}: IAnyProps) => {
  const [isActiveMediaItem, setIsActiveMediaItem] = useState();

  return (
    <ol className="ps-company-media-content__thumbnail-list-container">
      {mediaItems.map((mediaItem, index) => (
        <div
          data-company-name={company.name}
          key={index}
          onClick={() => setActiveMediaItem(mediaItem)}
        >
          {mediaItem.type === "video" && (
            <li
              className={`ps-company-media-content__thumbnail-list-item ${
                activeMediaItem.id === mediaItem.id ? "active" : ""
              }`}
            >
              {mediaItem.video_host === "youtube" && (
                <div className="ps-company-media-content__thumbnail-container">
                  <img
                    className="ps-company-media-content__thumbnail-image img-fluid"
                    src={`https://img.youtube.com/vi/${mediaItem.video_id}/default.jpg`}
                  />
                </div>
              )}

              {/* {mediaItem.video_host === "wistia" && (
                <div className="ps-company-media-content__thumbnail-container">
                  <img
                    src="https://fast.wistia.com/embed/medias/{{video_id}}/swatch"
                    className="ps-company-media-content__thumbnail-image img-fluid"
                    alt=""
                    // onLoad={(this.parentNode.style.opacity = 1)}
                    scale="0"
                  />
                </div>
              )} */}

              {mediaItem.video_host === "vimeo" && (
                <VimeoThumbnail mediaItem={mediaItem} />
              )}
            </li>
          )}

          {mediaItem.type === "image" && (
            <li
              className={`ps-company-media-content__thumbnail-list-item ${
                activeMediaItem.id === mediaItem.id ? "active" : ""
              }`}
            >
              <div className="ps-company-media-content__thumbnail-container">
                <img
                  className="ps-company-media-content__thumbnail-image"
                  src={mediaItem.image_url}
                />
              </div>
            </li>
          )}
        </div>
      ))}
    </ol>
  );
};

const VimeoThumbnail = ({ mediaItem }: IAnyProps) => {
  let [vimeoVideoThumbnailUrl, setVimeoVideoThumbnailUrl] = useState("");

  useEffect(() => {
    if (mediaItem.video_host !== "vimeo") {
      return;
    }

    const fetchVideoThumbail = async () => {
      let vimeoVideoUrl = "https://www.vimeo.com/" + mediaItem.video_id;
      let encodedVimeoVideoUrl = encodeURI(vimeoVideoUrl);

      let vimeoOEmbedUrl =
        "https://vimeo.com/api/oembed.json?url=" + encodedVimeoVideoUrl;

      let response;
      try {
        response = await axios.get(vimeoOEmbedUrl);
      } catch (err) {
        console.error(err);
      }

      let videoJsonData = response.data;

      if (videoJsonData) {
        setVimeoVideoThumbnailUrl(videoJsonData.thumbnail_url);
      }
    };

    fetchVideoThumbail();
  }, [mediaItem]);

  return (
    <div className="ps-company-media-content__thumbnail-container">
      <img
        src={vimeoVideoThumbnailUrl}
        className="ps-company-media-content__thumbnail-image"
      />
    </div>
  );
};
